import { render } from "./SweetLoader.vue?vue&type=template&id=6dcb6f32&scoped=true"
import script from "./SweetLoader.vue?vue&type=script&lang=js"
export * from "./SweetLoader.vue?vue&type=script&lang=js"

import "./SweetLoader.vue?vue&type=style&index=0&id=6dcb6f32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcb6f32"]])

export default __exports__